import { render } from "./Cookies.vue?vue&type=template&id=9551e134&ts=true"
import script from "./Cookies.vue?vue&type=script&lang=ts"
export * from "./Cookies.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__